export const coachMemberSessionOffsetKeys = {
    all: ['coachMemberSessionOffsets'] as const,
    list: (centerId: string, coachId: string, year: string, month: string) =>
        [...coachMemberSessionOffsetKeys.all, 'list', centerId, coachId, year, month] as const,
};
